import { IPublicClientApplication } from "@azure/msal-browser";
import { BaseService } from "./base.service";

export class TokenService extends BaseService {
  constructor(instance: IPublicClientApplication) {
    super(instance);
  }

  public async fetchTokenResponse(): Promise<any> {
    // Original
    // var options = this.getHeaderOption("GET");
    // const response = await fetch(`${this.getEndPoint()}/api/token`, options);

    // Mew Refetch Token
    const url = `${this.getEndPoint()}/api/token`;
    const method = "GET";

    const response = await this.getHeaderOptionWithToken(url, method);

    if (response.ok) {
      const responseAsJson = await response.json();
      const token = responseAsJson.token;
      if (token) {
        return responseAsJson;
      }
    }
    throw "Invalid token response";
  }
}
